import { EmpresaDtoHilab } from '../../core/_models'
import { EmpresaHilabView } from '../../core/_models'

export type EmpresaHilabFormValues = EmpresaDtoHilab & {
  senhaCadastrada: boolean
  segredoCadastrado: boolean
}

export const criarHilabFormValues = (hilab?: EmpresaHilabView): EmpresaHilabFormValues => ({
  ativo: hilab?.ativo ?? false,
  oauthUser: hilab?.oauthUser ?? '',
  oauthPassword: '',
  webhookHeaderName: hilab?.webhookHeaderName ?? '',
  webhookSecret: '',
  senhaCadastrada: hilab?.senhaCadastrada ?? false,
  segredoCadastrado: hilab?.segredoCadastrado ?? false,
})

const textoPreenchido = (valor?: string) => valor?.trim() || undefined

export const criarEmpresaDtoHilab = (hilab: EmpresaHilabFormValues): EmpresaDtoHilab => ({
  ativo: !!hilab.ativo,
  oauthUser: textoPreenchido(hilab.oauthUser),
  oauthPassword: textoPreenchido(hilab.oauthPassword),
  webhookHeaderName: textoPreenchido(hilab.webhookHeaderName),
  webhookSecret: textoPreenchido(hilab.webhookSecret),
})
